import React from "react";
import {
  ImageBackground,
  StyleSheet,
  TouchableOpacity,
  View,
} from "react-native";
import metrics from "@constants/metrics";
import BackArrow from "../../assets/svg/BackArrow";

const BannerHeader = (props) => {
  const {
    navigation,
    image_link = "",
    columns = null,
    link = "",
    link_type = "",
    sharingTemplate: { image_link: sharing_image_link = "", template = "" },
    sharingLink = "",
    video_link = "",
    cms_item_id = "",
    image_dimension_height = 1,
    image_dimension_width = 1,
  } = props;

  const aspectRatio = image_dimension_width / image_dimension_height;
  const width = metrics.screenWidth;
  const imageHeight = width / aspectRatio;

  return (
    <View
      style={[
        styles.relative,
        {
          width: metrics.screenWidth,
          height: imageHeight,
        },
      ]}
    >
      <ImageBackground
        source={{
          uri: image_link,
        }}
        style={{
          width: metrics.screenWidth,
          height: imageHeight,
          justifyContent: "center",
          padding: 18,
        }}
        onLoadEnd={() => {
          props.setLoading(false);
        }}
      >
        <TouchableOpacity
          style={{
            alignSelf: "flex-start",
          }}
          onPress={() => navigation.goBack()}
          hitSlop={{ top: 20, bottom: 15, left: 50, right: 25 }}
        >
          <BackArrow color={"#fff"} />
        </TouchableOpacity>
      </ImageBackground>
    </View>
  );
};

export default BannerHeader;

const styles = StyleSheet.create({
  relative: {
    position: "relative",
  },
});
